import { observer } from "mobx-react-lite";
import React, { Fragment, useContext } from "react";
import { RootStoreContext } from "../../../app/stores/rootStore";
import { Pagination, Segment, Table } from "semantic-ui-react";
import TeacherListItem from "./TeacherListItem";

const TeacherList: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const {
    teachersByName,
    loadTeachers,
    setPage,
    page,
    totalPages,
  } = rootStore.teacherStore;

  const onPageChange = (e: any, pageInfo: any) => {
    setPage(pageInfo.activePage);
    loadTeachers();
  };

  return (
    <Fragment>
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width={4}>Usuário</Table.HeaderCell>
            <Table.HeaderCell width={6}>Nome</Table.HeaderCell>
            <Table.HeaderCell width={6}>Email</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {teachersByName.map((user) => (
            <TeacherListItem key={user.id} user={user} />
          ))}
        </Table.Body>

        <Table.Footer>
          <Table.Row>
            <Table.HeaderCell colSpan="3">
              <Segment basic clearing floated="right">
                <Pagination
                  defaultActivePage={page}
                  onPageChange={(e, pageInfo) => onPageChange(e, pageInfo)}
                  totalPages={totalPages}
                />
              </Segment>
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      </Table>
    </Fragment>
  );
};

export default observer(TeacherList);
